import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

export interface PageMetaOptions {
  title: string;
  description?: string;
  imageUrl?: string;
}

/**
 * Título del documento y meta Open Graph / Twitter para vistas previas al compartir URL.
 */
@Injectable({
  providedIn: 'root',
})
export class SeoService {
  constructor(
    private readonly title: Title,
    private readonly meta: Meta,
    @Inject(DOCUMENT) private readonly document: Document
  ) {}

  setPageMeta(options: PageMetaOptions): void {
    const { title, description, imageUrl } = options;
    this.title.setTitle(title);
    this.meta.updateTag({ property: 'og:title', content: title });
    this.meta.updateTag({ name: 'twitter:title', content: title });
    const url = this.document.location?.href ?? '';
    if (url) {
      this.meta.updateTag({ property: 'og:url', content: url });
    }
    if (description) {
      this.meta.updateTag({ name: 'description', content: description });
      this.meta.updateTag({ property: 'og:description', content: description });
      this.meta.updateTag({ name: 'twitter:description', content: description });
    }
    if (imageUrl) {
      this.meta.updateTag({ property: 'og:image', content: imageUrl });
      this.meta.updateTag({ name: 'twitter:image', content: imageUrl });
    }
  }

  setSiteName(siteName: string): void {
    this.meta.updateTag({ property: 'og:site_name', content: siteName });
  }

  refreshCanonicalUrl(): void {
    const url = this.document.location?.href ?? '';
    if (url) {
      this.meta.updateTag({ property: 'og:url', content: url });
    }
  }

  /** Convierte ruta relativa de asset a URL absoluta para og:image */
  static absoluteAssetUrl(href: string): string | undefined {
    if (!href || typeof window === 'undefined') {
      return undefined;
    }
    if (/^https?:\/\//i.test(href)) {
      return href;
    }
    const path = href.replace(/^\.\//, '');
    const origin = window.location.origin;
    return `${origin}/${path}`;
  }
}
